
import {defineComponent} from "vue";
import {TvDetail, TvDetailIllustration} from "./models/SingleOfferDetail";

export default defineComponent({
    name: "InternetTvDetails",
    props: {
        title: {
            type: String,
            required: true
        },
        details: {
            type: Array as () => Array<TvDetail>,
            required: true
        },
        responsiveIllustration: {
            type: Object as () => TvDetailIllustration | null,
            required: false,
            default: null
        }
    },
    data() {
        return {
            mobileBackgroundStyle: null as object | null,
            desktopBackgroundStyle: null as object | null,
            screenWidth: document.documentElement.clientWidth
        };
    },
    computed: {
        isIllustrationPresent(): boolean {
            return (this.responsiveIllustration?.smallImageUrl
                && this.responsiveIllustration?.xsImageUrl) || false
        },
        isBackgroundIllustrationPresent(): boolean {
            return (this.responsiveIllustration?.xsBackgroundUrl
                && this.responsiveIllustration?.smallBackgroundUrl
                && this.responsiveIllustration?.mediumBackgroundUrl
                && this.responsiveIllustration?.largeBackgroundUrl
                && this.responsiveIllustration?.xlBackgroundUrl
                && this.responsiveIllustration?.xxlBackgroundUrl) || false;
        },
        xsBackgroundUrl(): string | null {
            return this.responsiveIllustration?.xsBackgroundUrl;
        },
        smallBackgroundUrl(): string | null {
            return this.responsiveIllustration?.smallBackgroundUrl;
        },
        mediumBackgroundUrl(): string | null {
            return this.responsiveIllustration?.mediumBackgroundUrl;
        },
        largeBackgroundUrl(): string | null {
            return this.responsiveIllustration?.largeBackgroundUrl;
        },
        xlBackgroundUrl(): string | null {
            return this.responsiveIllustration?.xlBackgroundUrl;
        },
        xxlBackgroundUrl(): string | null {
            return this.responsiveIllustration?.xxlBackgroundUrl;
        },
        xsImageUrl(): string | null {
            return this.responsiveIllustration?.xsImageUrl;
        },
        smallImageUrl(): string | null {
            return this.responsiveIllustration?.smallImageUrl;
        },
        imageAlt(): string | null {
            return this.responsiveIllustration?.imageAlt;
        },
        desktopBackgroundClass(): string {
            return this.isBackgroundIllustrationPresent ? 'popcorn-bg-desktop' : '';
        },
        mobileBackgroundClass(): string {
            return this.isBackgroundIllustrationPresent ? 'popcorn-bg-mobile' : '';
        },
        contentClass(): string | null {
            return this.isBackgroundIllustrationPresent ? 'popcorn-content' : null;
        },
    },
    mounted() {
        this.updateBackgroundStyles();
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        handleResize() {
            console.log('Window resized to:', document.documentElement.clientWidth);
            this.screenWidth = document.documentElement.clientWidth;
            this.updateBackgroundStyles();
        },
        updateBackgroundStyles() {
            console.log('Update background styles');
            this.mobileBackgroundStyle = this.getMobileBackgroundStyle();
            this.desktopBackgroundStyle = this.getDesktopBackgroundStyle();
        },
        getDesktopBackgroundStyle(): object {
            let backgroundUrl;

            if (this.screenWidth >= 1200) {
                backgroundUrl = this.xlBackgroundUrl;
            } else if (this.screenWidth >= 960) {
                backgroundUrl = this.largeBackgroundUrl;
            } else if (this.screenWidth >= 736) {
                backgroundUrl = this.mediumBackgroundUrl;
            } else {
                backgroundUrl = null;
            }

            return {
                backgroundImage: backgroundUrl ? 'url(' + backgroundUrl + ')' : 'none'
            };
        },
        getMobileBackgroundStyle(): object {
            let backgroundUrl;

            if (this.screenWidth >= 360) {
                backgroundUrl = this.smallBackgroundUrl;
            } else {
                backgroundUrl = this.xsBackgroundUrl;
            }

            return {
                backgroundImage: backgroundUrl ? 'url(' + backgroundUrl + ')' : 'none'
            };
        },
    }
});
